import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box, CircularProgress, Stack } from "@mui/material";

import { EmptyDataDiv, SearchInput } from ".";
import { UserFundraiser } from "./UserFundraiser";
import { UserFundraiserSkeleton } from "./skeletons";
import { fundRaiserPageAction } from "../store/actions";
import { SINGLE_OWNER_PAGE, TEAM_PAGE } from "../constants";
import { useNonInitialEffect } from "../hooks/UseNonInitialEffect";

export function UserFundraiserList({ listType }) {

    const dispatch = useDispatch();
    const user = useSelector(state => state.authentication.user);
    const pageList = useSelector(state => state.fundraiser_page.userFundraisers);
    const [userFundraisers, setUserFundraisers] = useState([]);
    const [totalFundtaisers, setTotalFundraisers] = useState(0);
    const [loadingPages, setLoadingPages] = useState(false);
    const MOST_RECENT = 1;
    const [state, setState] = useState({
        userId: user.id,
        offset: 0,
        limit: 6,
        pageType: listType,
        sortBy: MOST_RECENT,
        searchString: ""
    });

    const updateOffset = () => {
        setState({
            ...state,
            offset: state.offset + 6
        });
    }

    const updateState = (event) => {
        const { name, value } = event.target;
        setState({
            ...state,
            [name]: value
        })
    }

    const loadPages = async () => {
        const payload = {
            user_id: state.userId,
            offset: state.offset,
            limit: state.limit,
            page_type: state.pageType,
            sort_by: state.sortBy,
            search_page_title: state.searchString
        };

        await dispatch(fundRaiserPageAction.fundraiserPagesList(payload));
    }

    const showLoaderAndLoadPages = async () => {
        setLoadingPages(true);
        await loadPages();
        setLoadingPages(false);
    }

    const setPageList = () => {
        switch (listType) {
            case SINGLE_OWNER_PAGE:
                if (!state.offset && pageList.personalPages) {
                    setUserFundraisers(pageList.personalPages.result);
                    setTotalFundraisers(pageList.personalPages.total);
                }
                else if (state.offset)
                    setUserFundraisers([...userFundraisers, ...pageList.personalPages.result]);
                break;

            case TEAM_PAGE:
                if (!state.offset && pageList.teamPages) {
                    setUserFundraisers(pageList.teamPages.result);
                    setTotalFundraisers(pageList.teamPages.total);
                }

                else if (state.offset)
                    setUserFundraisers([...userFundraisers, ...pageList.teamPages.result]);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if ((listType == SINGLE_OWNER_PAGE && !pageList?.personalPages) || (listType == TEAM_PAGE && !pageList?.teamPages))
            showLoaderAndLoadPages();

        else setPageList()
    }, []);

    useNonInitialEffect(() => {
        setPageList();
    }, [pageList.personalPages, pageList.teamPages])

    useNonInitialEffect(() => {
        setState({
            ...state,
            offset: 0
        })
        const getData = setTimeout(() => {
            showLoaderAndLoadPages();
        }, 1000)

        return () => clearTimeout(getData)
    }, [state.searchString])

    useEffect(() => {
        if (state.offset > 0) {
            loadPages();
        }
    }, [state.offset])
    return <Box sx={{ width: '100%', border: '1px solid #e8e8e8', padding: '15px' }}>
        <Stack spacing={2}>
            <SearchInput
                id="searchString"
                name="searchString"
                placeholder="Search Fundraisers"
                size="small"
                value={state.searchString}
                onChange={updateState}
                fullWidth
            />
            {
                !userFundraisers.length && !loadingPages && <EmptyDataDiv message="No Fundraiser pages found." />
            }
            {userFundraisers && !loadingPages ?
                <InfiniteScroll
                    dataLength={userFundraisers.length}
                    next={updateOffset}
                    hasMore={userFundraisers.length < totalFundtaisers}
                    loader={
                        <div style={{ textAlign: "center" }}>
                            <CircularProgress thickness={2} />
                        </div>
                    }
                    style={{
                        overflow: 'hidden'
                    }}
                >
                    {
                        userFundraisers.map(page => {
                            return <UserFundraiser item={page} key={page.id} listType={listType} />
                        })
                    }
                </InfiniteScroll> :
                <UserFundraiserSkeleton />
            }
        </Stack>
    </Box>
}